<template>
  <div>
    <el-date-picker
      v-model="valueTime"
      type="datetimerange"
      align="right"
      start-placeholder="开始日期"
      end-placeholder="结束日期"
      value-format="timestamp"
    >
    </el-date-picker>
    <el-table :data="tableData">
      <el-table-column prop="info" label="信息"></el-table-column>
      <el-table-column prop="action" label="操作"></el-table-column>
      <el-table-column prop="timestamp" label="时间">
        <template slot-scope="scope">
          <el-row>
            {{ new Date(scope.row.timestamp * 1000).toLocaleString() }}
          </el-row>
        </template>
      </el-table-column>
    </el-table>
  </div>
</template>

<script>
export default {
  data() {
    return {
      tableData: [],
      valueTime: [],
      startTimestamp: 0,
      endTimestamp: 0,
    };
  },
  methods: {
    getLogouts() {
      var api = "/getLog/";
      this.axios
        .get(
          api,
          {
            params: {
              start: this.startTimestamp,
              end: this.endTimestamp,
            },
          }
          //   this.$qs.stringify({
          //     token: token,
          //   })
        )
        .then((response) => {
          console.log(response.data);
          if (response.data.code == 200) {
            this.$message(response.data.message);
            this.tableData = response.data.data;
          } else {
            this.$message.error(response.data.message);
          }
        });
    },
  },
  mounted() {
    this.getLogouts();
  },
  watch: {
    valueTime(oldV, newV) {
      if(oldV.length==2 && newV.length==0){
          newV = oldV;
      }
      if (newV.length == 2) {
        this.startTimestamp = parseInt(newV["0"]) / 1000;
        this.endTimestamp = parseInt(newV["1"]) / 1000;
      }
      this.getLogouts();
    },
  },
};
</script>

<style>
</style>